import { type BoundaryGroupDemographic } from '~/store/boundaryGroups/boundaryGroups.repository';
import { type SpreadsheetColumn } from '../../types/spreadsheetData/spreadsheetColumn';
import { type MetricsDataAction } from '../../utils/metric/metrics.types';

export enum SelectedDataType {
  SpreadsheetColumn = 'SpreadsheetColumn',
  Demographic = 'Demographic'
}

export type SelectedDataSpreadsheetColumnGroupTotal = {
  type: SelectedDataType.SpreadsheetColumn;
  primarySpreadsheetColumn: SpreadsheetColumn;
  dataAction: MetricsDataAction.GROUP_TOTAL;
  secondarySpreadsheetColumn: SpreadsheetColumn;
};

export type SelectedDataSpreadsheetColumnValue = {
  type: SelectedDataType.SpreadsheetColumn;
  primarySpreadsheetColumn: SpreadsheetColumn;
  dataAction: MetricsDataAction.LOW_VALUE | MetricsDataAction.HIGH_VALUE | MetricsDataAction.SUM | MetricsDataAction.AVERAGE | MetricsDataAction.GROUP_COUNT;
};

export type SelectedDataSpreadsheetColumn = SelectedDataSpreadsheetColumnGroupTotal | SelectedDataSpreadsheetColumnValue;

export type SelectedDataDemographic = {
  type: SelectedDataType.Demographic;
  selectedDemographic: BoundaryGroupDemographic;
};

export type SelectedDataMetric = SelectedDataSpreadsheetColumn | SelectedDataDemographic;
